<template>
  <div class="c-offline-class-wrap bg-lightgrey" :style="{'min-height': clientHeight + 'px'}">
    <div>
      <div class="c-fixed">
        <div class="c-cats-wrap" ref="cats2">
          <div
            class="item"
            :id="'cats2-all'"
            :class="curCid == '' ? 'active' : ''"
            @click="changeCat('')"
          >
            全部
            <span></span>
          </div>
          <template v-for="c in cats" :key="c.id">
            <div
              class="item"
              :class="this.curCid == c.id ? 'active' : ''"
              :id="'cats2-'+c.id"
              @click="changeCat(c.id)"
              v-if="c.categoryNum > 0"
            >
              {{c.name}}
              <span></span>
            </div>
          </template>
        </div>
        <div class="c-filters">
          <div class="c-filters-tag">
            <gxxt-tag
              class="w200"
              size="large"
              color="#f1f1f1"
              :text-color="filters.filterVal == 0 && showMask ? '#f50' : '#888'"
              round
              :value="0"
              @click="selectFilter"
            >
              <div class="flex-c">
                <i class="iconfont icon-dingwei1 mr10"></i>
                <template v-if="!filters.cityVal || filters.cityVal=='全部'">选择城市</template>
                <template v-else>{{filters.cityVal}}</template>
                <i class="iconfont icon-zhankaijiantou ml5"></i>
              </div>
            </gxxt-tag>
            <gxxt-tag
              class="w200 ml20"
              size="large"
              color="#f1f1f1"
              :text-color="filters.filterVal == 1 && showMask ? '#f50' : '#888'"
              round
              :value="1"
              @click="selectFilter"
            >
              <div class="flex-c">
                <i class="iconfont icon-shijian1 mr10"></i>
                <template v-if="!filters.timeVal">选择时间</template>
                <template v-else>{{filters.times[filters.timeVal]}}</template>
                <i class="iconfont icon-zhankaijiantou ml5"></i>
              </div>
            </gxxt-tag>
          </div>
          <!-- 城市 -->
          <div class="c-filters-list" v-if="filters.filterVal == 0 && showMask">
            <div v-show="cityLoading"></div>
            <!-- todo v-loading directive -->
            <gxxt-tag
              v-for="(t, index) in filters.cities"
              :key="index"
              class="mb20"
              size="large"
              color="#f1f1f1"
              :text-color="t == filters.cityVal ? '#f50' : '#333'"
              round
              :value="t"
              @click="changeCityVal"
            >{{t}}</gxxt-tag>
          </div>
          <div class="c-filters-list" v-if="filters.filterVal == 1 && showMask">
            <gxxt-tag
              v-for="(t, index) in filters.times"
              :key="index"
              class="mb20"
              size="large"
              color="#f1f1f1"
              :text-color="index == filters.timeVal ? '#f50' : '#333'"
              round
              :value="index"
              @click="changeTimeVal"
            >{{t}}</gxxt-tag>
          </div>
        </div>
      </div>
      <div v-show="showMask" class="c-mask" @touchend="closeMask"></div>
      <div class="nodata" v-if="nodata">— 未匹配到对应课程，看看其他课程吧 —</div>
      <div class="c-split"></div>
    </div>
    <ul>
      <li v-for="it in list" :key="it.resourceId">
        <list-item
          :adminId="adminId"
          :origin="origin"
          :item="it"
          :items="it.items"
          :goodsType="goodsType"
        ></list-item>
      </li>
    </ul>
    <div class="nomore" v-if="!nodata && !showLoading">— 没有更多课程啦，看看其他课程吧 —</div>
    <div class="c-label" v-if="recommendList.length > 0">推荐课程</div>
    <ul v-if="recommendList.length > 0">
      <li v-for="it in recommendList" :key="it.resourceId">
        <list-item
          :adminId="adminId"
          :origin="origin"
          :item="it"
          :items="it.items"
          :goodsType="goodsType"
        ></list-item>
      </li>
    </ul>
    <GxxtPageLoading v-show="showLoading"></GxxtPageLoading>
  </div>
  <footer-nav :active="3" v-if="!origin"></footer-nav>
  <popup :adPage="12"></popup>
</template>

<script>
import { GxxtTag, GxxtPageLoading } from '@/components'
import { wxShare, wxGeoLocation } from '@/utils/wx-config'
import { getAddress } from '@/utils/qqMap'
import ListItem from './components/offline-class-item.vue'
import footerNav from '@/pages/public/footer-nav.vue'
import popup from '@/pages/public/popup.vue'
export default {
  components: {
    GxxtTag,
    GxxtPageLoading,
    ListItem,
    footerNav,
    popup,
  },
  data() {
    return {
      filters: {
        times: ['全部', '一周内', '一月内', '三月内', '半年内'],
        cities: [],
        timeVal: 0,
        cityVal: null,
        filterVal: -1,
      },
      timer: null,
      list: [],
      cats: [],
      curCid: '',
      recommendList: [],
      origin: '', //来源
      goodsType: this.constants.goodsType.offlineClass,
      nodata: false,
      showMask: false,
      showLoading: false,
      cityLoading: false,
      adminId: '',
    }
  },
  unmounted() {
    this.timer && clearTimeout(this.timer)
  },
  methods: {
    async getH5Cats() {
      let res = await this.api.course.getH5Cats(
        this.constants.goodsType.offlineClass
      )
      if (res && res.code == 200) {
        this.cats = res.data
      }
    },
    changeCat(cid) {
      if (cid == this.curCid) return
      this.curCid = cid
      this.getOfflineClasses(cid)

      let w = 686 * this.ratio
      let ofl = document.getElementById(
        'cats2-' + (cid ? cid : 'all')
      ).offsetLeft
      let sl = ofl - w / 2
      // if (sl > 0) {
      this.$refs['cats2'].scrollLeft = sl
      // }
    },
    getLists() {
      this.getCities()
      this.getOfflineClasses()
    },
    async getCities() {
      this.cityLoading = true
      let res = await this.api.course.getCities()
      if (res && res.code == 200) {
        this.filters.cities = res.data
        this.filters.cities.unshift('全部')
        this.geoLocation()
      }
      this.cityLoading = false
    },
    async getOfflineClasses() {
      this.showLoading = true
      let data = {
        timeType: this.filters.timeVal,
        classifyId: this.curCid,
      }
      if (this.filters.cityVal && this.filters.cityVal != '全部') {
        data.city = this.filters.cityVal
      }
      this.list = []
      this.recommendList = []
      let res = await this.api.course.getOfflineTimetableList(data)
      if (res && res.code == 200) {
        let resList = res.data.list
        resList =
          Object.prototype.toString.apply(resList) == '[object Array]'
            ? resList
            : []
        if (resList.length == 0) {
          this.nodata = true
        } else {
          this.nodata = false
        }

        resList.forEach((el) => {
          if (Object.prototype.toString.apply(el.items) == '[object Array]') {
            if (
              Object.prototype.toString.apply(el.items[0]) == '[object Object]'
            ) {
              this.list.push({
                ...el.items[0],
                phaseList: el.items.slice(1),
              })
            }
          }
        })

        let recommendList = res.data.recommend ? res.data.recommend : []
        recommendList.forEach((el) => {
          if (Object.prototype.toString.apply(el.items) == '[object Array]') {
            if (
              Object.prototype.toString.apply(el.items[0]) == '[object Object]'
            ) {
              this.recommendList.push({
                ...el.items[0],
                phaseList: el.items.slice(1),
              })
            }
          }
        })
      }
      this.showLoading = false
    },
    selectFilter(val) {
      this.filters.filterVal = val
      this.showMask = true
    },
    changeTimeVal(val) {
      this.filters.timeVal = val
      this.getOfflineClasses()
      this.showMask = false
    },
    changeCityVal(val) {
      this.filters.cityVal = val
      this.getOfflineClasses()
      this.showMask = false
    },
    closeMask() {
      this.timer = setTimeout(() => {
        this.showMask = false
        this.filterVal = -1
      }, 200)
    },
    selectTab(goodsType) {
      this.goodsType = goodsType
      this.getLists()
      this.$router.push({
        name: 'timetable',
        query: {
          goodsType: goodsType,
          origin: this.origin,
          adminId: this.adminId,
        },
      })
    },
    shareOut() {
      let link =
        window.location.protocol +
        '//' +
        window.location.host +
        '#/home?origin=h5'
      let shareInfo = {
        title: 'CEO的新商业学堂',
        desc: '打造人才资本，练就管理真功夫',
        link: link,
        imgUrl: this.constants.logo,
      }
      let callback = () => {}
      wxShare({ shareInfo, callback })
    },
    geoLocation() {
      let self = this
      let callback = (res) => {
        getAddress({
          callback: (city) => {
            if (this.filters.cities.indexOf(city) > -1) {
              self.filters.cityVal = city
            } else {
              this.$toaster({
                message: '您当前所在的城市暂无课程,自动为您显示全部课程',
                duration: 3000,
                show: true,
              })
            }
            if (self.goodsType == self.constants.goodsType.offlineClass) {
              self.getOfflineClasses()
            }
          },
          lat: res.latitude,
          lng: res.longitude,
        })
      }
      wxGeoLocation(callback)
    },
  },
  created() {
    this.origin = this.$route.query.origin
    this.adminId = this.$route.query.adminId
    this.getLists()
  },
  mounted() {
    this.getH5Cats()
    this.shareOut()
  },
}
</script>
<style lang="less" scoped>
.c-offline-class-wrap {
  text-align: left;
  padding: 160px 32px 146px !important;
}

.nomore {
  padding: 20px 0 40px;
  text-align: center;
  color: #888888;
  font-size: 28px;
}
.nodata {
  padding: 120px 0 60px;
  text-align: center;
  color: #888888;
  font-size: 28px;
}
.c-filters {
  // background: #fff;
  z-index: 9;
  padding: 20px 32px 32px;
  .c-filters-tag {
    font-size: 0;
  }
  .icon-dingwei1 {
    font-size: 28px;
  }
  .icon-shijian1 {
    font-size: 28px;
  }
  .icon-zhankaijiantou {
    display: inline-block;
    font-size: 20px;
    transform: scale(0.8);
  }
}
.c-label {
  font-size: 36px;
  font-weight: 500;
  color: #303030;
  line-height: 96px;
}
.c-split {
  border-top: 1px solid #f1f1f1;
  margin-top: 30px;
}
.c-filters-list {
  margin: 0 -20px;
  padding-top: 30px;

  .gxxt-tag {
    margin: 0 20px;
    min-width: 106px;
  }
}
.c-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.16);
  z-index: 1;
}
.c-fixed {
  position: fixed;
  top: 0;
  width: 750px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #f7f7f9;
  z-index: 2;
}
::-webkit-scrollbar {
  display: none;
}
.c-cats-wrap {
  display: flex;
  overflow: auto;
  padding: 20px 0 10px 32px;
  scroll-behavior: smooth;
  .item {
    font-size: 30px;
    font-weight: 500;
    color: #888888;
    line-height: 66px;
    margin-right: 50px;
    position: relative;
    white-space: nowrap;
  }
  .active {
    color: #333;
    span {
      width: calc(100% - 10px);
    }
  }
  span {
    display: block;
    width: 0;
    position: absolute;
    height: 6px;
    border-radius: 3px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #f50;
    transition: width 0.3s;
  }
}
</style>